export const prefersReducedMotion = () => {
  if (!window.matchMedia) {
    return false;
  }
  const result = window.matchMedia("(prefers-reduced-motion)");
  return result && result.matches;
};
